export const NO_BOM = 'NO_BOM';
export const IMPORTING = 'IMPORTING';
export const READY = 'READY';
export const QUOTING_BOM_PARTS = 'QUOTING';
export const QUOTED = 'QUOTED';
